import React, { useEffect, useState } from 'react';
import { Box, Button, MenuItem, TextField, useTheme } from '@mui/material';
import { FaFilter } from 'react-icons/fa';
import dayjs, { Dayjs } from 'dayjs';
import { Grid } from "@material-ui/core";
import useGlobalContext from "../../Hooks/useGlobalContext";
import getInitialDataFilter from "./initialDataFilter";
import { IFilter } from "./types";

const primaryColor = '#1c2e4a';

const NcmPageFilter: React.FC = () => {
    const theme = useTheme(); // Suporte a dark mode

    const { filters, setFilters, showFilters, setShowFilters } = useGlobalContext();

    const [initialDate, setInitialDate] = useState<Dayjs | null>(dayjs(filters?.startDate || undefined));
    const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | null>(dayjs(filters?.endDate || undefined));
    const [codigo_ncm, setCodigo] = useState<string>(filters?.codigo_ncm || '');
    const [codigo_pai_ncm, setCodigoPai] = useState<string>(filters?.codigo_pai_ncm || '');
    const [descricao_ncm, setDescricao] = useState<string>(filters?.descricao_ncm || '');
    const [inicio_vigencia_ncm, setInicioVigencia] = useState<string>(filters?.inicio_vigencia_ncm || '');
    const [fim_vigencia_ncm, setFimVigencia] = useState<string>(filters?.fim_vigencia_ncm || '');
    const [selectedButton, setSelectedButton] = useState('');
    const [loading, setLoading] = useState(false);

    const runFilters = () => {
        if (setFilters) {
            setFilters((prev) => ({
                ...prev,
                startDate: initialDate?.format('YYYY-MM-DD') || '',
                endDate: selectedEndDate?.format('YYYY-MM-DD') || '',
                establishment: '',
                codigo_ncm: codigo_ncm || '',
                codigo_pai_ncm: codigo_pai_ncm || '',
                descricao_ncm: descricao_ncm || '',
                inicio_vigencia_ncm: inicio_vigencia_ncm || '',
                fim_vigencia_ncm: fim_vigencia_ncm || ''
            }));
        }
    };

    const clearFilters = () => {
        if (setFilters) {
            setFilters(getInitialDataFilter());
        }
        setCodigo('');
        setCodigoPai('');
        setDescricao('');
    };

    const isToday = (date: string) => {
        const today = dayjs();
        const givenDate = dayjs(date);
        return givenDate.isSame(today, 'day');
    };

    useEffect(() => {
        if (initialDate && selectedEndDate && isToday(selectedEndDate.format('YYYY-MM-DD'))) {
            const days = (selectedEndDate?.diff(initialDate, 'day')) ?? 0
            setSelectedButton((days + 1) + '');
        } else {
            setSelectedButton('0');
        }
    }, [initialDate, selectedEndDate]);

    useEffect(() => {
        if (filters?.startDate) setInitialDate(dayjs(filters.startDate));
        if (filters?.endDate) setSelectedEndDate(dayjs(filters.endDate));
    }, [filters]);

    const setDataPageFilter = (filtersParam: IFilter | undefined) => {
        if (filtersParam) {
            setInitialDate(dayjs(filtersParam.startDate || undefined));
            setSelectedEndDate(dayjs(filtersParam.endDate || undefined));
        }
    };

    return (
        <Grid item xs={12} md={12} lg={12}>
            <Box sx={{ backgroundColor: theme.palette.background.paper }} p={1}>
                <Grid item xs={12}>
                    <Button onClick={() => setShowFilters?.((n: boolean) => !n)}>
                        <span style={{ marginRight: '10px' }}><FaFilter /></span>
                        {showFilters ? 'Esconder Filtros' : 'Mostrar Filtros'}
                    </Button>
                </Grid>

                {showFilters && (
                    <Grid item xs={12} style={{ marginTop: 2 }} component="section">
                        <Grid container spacing={2} style={{ maxWidth: '100%' }}>
                            <Grid item xs={12} sm={3} md={4} lg={4}>
                                <TextField
                                    label="CÓDIGO"
                                    disabled={loading}
                                    variant="outlined"
                                    value={codigo_ncm}
                                    onChange={e => setCodigo(e.target.value)}
                                    onClick={() => setCodigo('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={4} lg={4}>
                                <TextField
                                    label="CÓDIGO PAI"
                                    disabled={loading}
                                    variant="outlined"
                                    value={codigo_pai_ncm}
                                    onChange={e => setCodigoPai(e.target.value)}
                                    onClick={() => setCodigoPai('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={4} lg={4}>
                                <TextField
                                    label="DESCRIÇÃO"
                                    disabled={loading}
                                    variant="outlined"
                                    value={descricao_ncm}
                                    onChange={e => setDescricao(e.target.value)}
                                    onClick={() => setDescricao('')}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6} style={{ marginBottom: 2 }}>
                                <Button
                                    sx={{
                                        borderRadius: '0px',
                                        border: '1px solid',
                                        margin: '0',
                                        width: '100%'
                                    }}
                                    disabled={loading}
                                    onClick={clearFilters}
                                >
                                    Limpar filtros
                                </Button>
                            </Grid>
                            <Grid item xs={6} style={{ marginBottom: 2 }}>
                                <Button
                                    sx={{
                                        borderRadius: '0px',
                                        border: '1px solid #1c2e4a',
                                        margin: '0',
                                        backgroundColor: primaryColor,
                                        color: 'white',
                                        width: '100%'
                                    }}
                                    disabled={loading}
                                    onClick={runFilters}
                                >
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Box>
        </Grid>
    );
};

export default NcmPageFilter;
